import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { GlobalErrorHandler } from '..'

export class FinstrongApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  calculateHealthScore = async () => {
    return this.fetchInstance
      .post(`${ApiEndpoints.HEALTH_SCORES}/calculate`)
      .then((data) => data.health_score)
  }

  getAverageHealthScores = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.HEALTH_SCORES}/monthly_averages`)
      .then((data) => data)
  }

  getDebtSpend = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.HEALTH_SCORES}/transactions/debt_spend`)
      .then((data) => data)
  }

  getIncome = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.HEALTH_SCORES}/transactions/income`)
      .then((data) => data)
  }

  getMonthlySummaries = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.HEALTH_SCORES}/monthly_summaries`)
      .then((data) => data)
  }

  getHealthScoreChangeReports = async (startDate: number, endDate: number) => {
    return this.fetchInstance
      .get(`${ApiEndpoints.HEALTH_SCORES}/change_report/from/${startDate}/to/${endDate}`)
      .then((data) => data)
  }

  getPeerScore = async (birthYear: string) => {
    return this.fetchInstance
      .get(`${ApiEndpoints.HEALTH_SCORES}/average/${birthYear}`)
      .then((data) => data)
  }

  getSpendingFeeTransactions = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.HEALTH_SCORES}/transactions/spending_fee`)
      .then((data) => data)
  }

  getStandardSpend = async () => {
    return this.fetchInstance
      .get(`${ApiEndpoints.HEALTH_SCORES}/transactions/standard_spend`)
      .then((data) => data)
  }
}
